import { useState } from "react";

const useTabFocus = (cb: () => void, focusedClassName: string) => {
  const [isFocused, setIsFocused] = useState(false);

  const onFocus = () => setIsFocused(true);

  const onBlur = () => setIsFocused(false);

  const onKeyDown = (e: any) => {
    if ((e as unknown as KeyboardEvent).key === "Enter" && isFocused) {
      cb();
    }
  };

  // Focusable element props
  return {
    onFocus,
    onBlur,
    onKeyDown,
    tabIndex: 0,
    className: isFocused ? focusedClassName : "",
  };
};

export default useTabFocus;
